import { useEffect, useState } from "react";
import { ChevronDown, ChevronUp } from "react-bootstrap-icons";
import { SubmitHandler, useForm } from "react-hook-form";
import FormButton from "../../Components/Buttons/FormButton";
import FormButtonDisable from "../../Components/Buttons/FormButtonDisable";
import MultipleCheckboxDropdownGroup from "../../Components/FormTag/MultipleCheckboxDropdownGroup";
import MultipleCheckboxDropdown from "../../Components/MultipleCheckboxDropdown";
import { Mapping } from "./model/Client.type";
import {
  clientWarehouseList,
  inboundOutboundList,
} from "../../Data/dropdownDataList";
import { useNavigate } from "react-router-dom";

interface WarehouseWorkflow {
  header: string;
  data: string;
}

interface WarehousePanel {
  [key: string]: WarehouseWorkflow[];
}

interface ClientMappingProps {
  handleNext: () => void;
}
export default function ClientMapping(props: ClientMappingProps) {
  const navigation = useNavigate();
  const { handleNext } = props;
  const [clientMappingData, setClientMappingData] = useState<Mapping>(
    new Mapping()
  );
  const [accordionPanelsList, setAccordionPanelsList] = useState<
    WarehousePanel[]
  >([]);
  const [collapseStates, setCollapseStates] = useState<boolean[]>(
    accordionPanelsList.map(() => true)
  );
  const {
    handleSubmit,
    register,
    reset,
    control,
    formState: { errors },
    watch,
  } = useForm<Mapping>({
    defaultValues: clientMappingData,
  });
  const watchClientWarehouse = watch("clientWarehouse");
  const saveMapping: SubmitHandler<Mapping> = (data) => {
    const updatedAccordionPanelsList: WarehousePanel[] = [
      ...accordionPanelsList,
    ];
    data.clientWarehouse.forEach((warehouse) => {
      const existingWarehouseIndex = updatedAccordionPanelsList.findIndex(
        (panel) => Object.keys(panel)[0] === warehouse.label
      );
      if (existingWarehouseIndex !== -1) {
        const existingWorkflows = updatedAccordionPanelsList[existingWarehouseIndex][warehouse.label];
        data.clientWorkflow.forEach((workflow)=>{
          const workflowIndex = existingWorkflows.findIndex(
            (existingWorkflow) => existingWorkflow.data === workflow.key
          );
          const newWorkflow = {
            header: workflow.category,
            data: workflow.key,
          };
          if (workflowIndex !== -1) {
            existingWorkflows[workflowIndex] = newWorkflow;
          } else {
            existingWorkflows.push(newWorkflow);
          }
        })
      } else {
        const warehouseObj: WarehousePanel = { [warehouse.label]: [] };
        data.clientWorkflow.forEach((workflow) => {
          warehouseObj[warehouse.label].push({
            header: workflow.category,
            data: workflow.key,
          });
        });

        updatedAccordionPanelsList.push(warehouseObj);
      }
    });
    updatedAccordionPanelsList.map((item, index) => {
      toggleCollapse(index);
    });

    setAccordionPanelsList(updatedAccordionPanelsList);
    reset(new Mapping());
  };
  const handelCancelBtn = () => {
    navigation("/account/client/overview/grid-view");
  };
  const toggleCollapse = (index: number) => {
    const updatedCollapseStates = [...collapseStates];
    updatedCollapseStates[index] = !updatedCollapseStates[index];
    setCollapseStates(updatedCollapseStates);
  };
  const handelNext = () => {
    handleNext();
  };
  useEffect(() => {
    setCollapseStates(accordionPanelsList.map(() => true));
  }, [accordionPanelsList]);
  return (
    <>
      <div className="my-2 bg-white rounded py-4">
        <div className="d-flex  ps-4 justify-content-between">
          <div className="d-flex col-10">
          <div className="col-6 px-2">
            <label className="fw-medium">Select Warehouse(s)</label>
            <div className="mt-1">
              <MultipleCheckboxDropdown
                control={control}
                name="clientWarehouse"
                className="form-select cursor-pointer"
                optionsList={clientWarehouseList}
                errors={errors.clientWarehouse}
                required={true}
              />
            </div>
          </div>
          <div className="col-6 px-2">
            <label className="fw-medium">Select Workflow</label>
            <div className="mt-1">
              <MultipleCheckboxDropdownGroup
                control={control}
                name="clientWorkflow"
                optionsList={inboundOutboundList}
                className="form-select cursor-pointer"
                watchData={!watchClientWarehouse.length}
                errors={errors.clientWorkflow}
                required={true}
              />
            </div>
          </div>
          </div>
          <div className="me-2 col-2">
            <FormButtonDisable
              className="sph-btn ms-3 margin-top-28"
              handleClick={handleSubmit(saveMapping)}
            >
              Add
            </FormButtonDisable>
          </div>
        </div>
      </div>
      {/* Accordion panels */}
      <div className="d-flex flex-column min-height-41">
        {accordionPanelsList.map((warehouseObj, index) => (
          <div
            key={index}
            className="my-2 bg-white rounded py-3"
            id={`accordionPanel${index}`}
          >
            <div className="d-flex justify-content-between align-item-center px-3">
              <div className="align-self-center">
                {collapseStates[index] === false ? (
                  <div className="text-secondary fw-light">
                    <small>Warehouse</small>
                  </div>
                ) : (
                  ""
                )}
                <h6 className="fw-bold mb-0">{Object.keys(warehouseObj)[0]}</h6>
              </div>
              <div className="align-self-center">
                <span
                  className="badge rounded-pill sph-text-bg-light-grey cursor-pointer"
                  onClick={() => toggleCollapse(index)}
                >
                  {collapseStates[index] ? <ChevronUp /> : <ChevronDown />}
                </span>
              </div>
            </div>
            {/* Conditional rendering based on collapse state */}
            {collapseStates[index] && (
              <div
                className="mt-2 px-4 accordion-collapse collapse show"
                id={`accordionCollapse${index}`}
              >
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-12 mapping-grid pe-0 ps-3">
                    <div className="">
                      {" "}
                      <strong>Inbound Workflow</strong>
                    </div>
                    {warehouseObj[Object.keys(warehouseObj)[0]].map(
                      (workflow, idx) => (
                        <>
                          <div>
                            {workflow.header === "Inbound" && workflow.data}
                          </div>
                        </>
                      )
                    )}
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 ps-0">
                    <div className="">
                      {" "}
                      <strong>Outbound Workflow</strong>
                    </div>
                    {warehouseObj[Object.keys(warehouseObj)[0]].map(
                      (workflow, idx) => (
                        <>
                          <div>
                            {workflow.header === "Outbound" && workflow.data}
                          </div>
                        </>
                      )
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
        <div className="my-2 bg-white rounded py-3 cta-div mt-auto">
          <div className="d-flex flex-row-reverse">
            <FormButton className="sph-btn me-4" handleClick={handelNext}>
              Next
            </FormButton>
            <FormButton
              className="sph-btn sph-shift me-4"
              handleClick={handelCancelBtn}
            >
              Cancel
            </FormButton>
          </div>
        </div>
      </div>
    </>
  );
}
